import { useSelector } from 'react-redux';
import { useLocation } from '@reach/router';

import { getQuestion } from 'selectors/questions';
import { getChapter } from 'selectors/chapters';
import { getTopic } from 'selectors/topics';
import useTrackerBasicInfo from 'hooks/useTrackerBasicInfo';
import { Topic } from 'models/topic';

export type EditorEventParams = {
  user_id: string;
  organization_id: string;
  country: string;
  course_id: string;
  unit_id: string;
  topic_id: string;
  chapter_id?: string | null;
  question_id?: string | null;
  position_number: number | null;
};

const useEditorEventParams = (): EditorEventParams => {
  const { pathname } = useLocation();
  const trackerBasicInfo = useTrackerBasicInfo();

  const entityId = pathname.split('/')[3] ?? '';
  const question = useSelector(getQuestion(entityId));
  const chapter = useSelector(getChapter(entityId));
  const topicQuestion = useSelector(getTopic(question?.topic_id ?? ''));
  const topicChapter = useSelector(getTopic(chapter?.topic_id ?? ''));
  const topic: Topic = topicQuestion || topicChapter;
  const course_id = topic?.course_id ?? '';
  const unit_id = topic?.bundle_id ?? '';

  if (pathname.includes('import')) {
    return {
      ...trackerBasicInfo,
      course_id: course_id,
      unit_id: unit_id,
      topic_id: pathname.split('/')[3] ?? '',
      question_id: null,
      position_number: null,
    };
  }

  let positionNumber = question?.position ? question.position + 1 : 0;
  if (!positionNumber) {
    if (question && topic?.questions) {
      positionNumber =
        topic.questions.findIndex((q: { id: string }) => q.id === entityId) + 1;
    }

    if (chapter && topic?.lesson?.chapters) {
      positionNumber =
        topic.lesson.chapters.findIndex(
          (c: { id: string }) => c.id === entityId,
        ) + 1;
    }
  }

  const trackerParams = {
    ...trackerBasicInfo,
    course_id: course_id,
    unit_id: unit_id,
    topic_id: question?.topic_id ?? chapter?.topic_id ?? '',
  };

  if (question) {
    return {
      ...trackerParams,
      question_id: question?.id,
      position_number: positionNumber,
    };
  }

  // chapter
  return {
    ...trackerParams,
    chapter_id: chapter?.id,
    position_number: positionNumber,
  };
};

export default useEditorEventParams;
